import React from 'react';
import PropTypes from 'prop-types';
import { FormSection } from 'react/containers/layout/Crud';
import Loading from 'react/components/Loading';

import resources from 'react/containers/pages/TicketDetails/ticketDetailsResources';
import { resourceFrom, formatDate, checkIfDataExist } from 'react/containers/pages/TicketDetails/ticketDetailsUtils';

const thCell = (label, customCss) => (
  <th className={`tasksRelatedSection__head-col ${customCss}`}>
    {label}
  </th>
);

const tbCell = (label) => (
  <td className="tasksRelatedSection__body-col">
    {label}
  </td>
);

const tbCellWithLink = (id) => (
  <td className="tasksRelatedSection__body-col">
    <a href={`#/Task/edit/${id}`}><span className="fa fa-edit" /></a>
  </td>
);

const renderFields = (data) => {
  if (!data?.get?.('id')) {
    return <div>{resourceFrom(resources.dataNotFound)}</div>;
  }

  if (data.getIn?.(['ticketLinked', 'tasks'])?.size) {
    const tasks = data.getIn(['ticketLinked', 'tasks']);
    return (
      <>
        <table className="tasksRelatedSection__table">
          <thead>
            <tr>
              {thCell('', 'first-colunm')}
              {thCell(resourceFrom(resources.created))}
              {thCell(resourceFrom(resources.taskType))}
              {thCell(resourceFrom(resources.dueDate))}
              {thCell(resourceFrom(resources.ticketStatus.label))}
              {thCell(resourceFrom(resources.ticketResolution))}
              {thCell(resourceFrom(resources.attendant))}
            </tr>
          </thead>
          <tbody>
            {tasks.map((task) => (
              <tr key={task.get('id')} className="tasksRelatedSection__body-row">
                {tbCellWithLink(task.get('id'))}
                {tbCell(formatDate(task.get('created')))}
                {tbCell(checkIfDataExist(task.getIn(['type', 'description'])))}
                {tbCell(formatDate(task.get('dueDate')))}
                {tbCell(resourceFrom(checkIfDataExist(task.getIn(['taskStatus', 'description']))))}
                {tbCell(checkIfDataExist(task.getIn(['taskResolution', 'description'])))}
                {tbCell(checkIfDataExist(task.getIn(['userAssigned', 'name'])))}
              </tr>
            ))}
          </tbody>
        </table>
      </>
    );
  }

  return <div>{resourceFrom(resources.noTaskRelated)}</div>;
};

function TasksRelatedSection(props) {
  const { isLoading, data } = props;

  return (
    <FormSection title="TicketDetails.section.tasksRelated.title" className="tasksRelatedSection">
      {isLoading
        ? <Loading />
        : renderFields(data)}
    </FormSection>
  );
}

TasksRelatedSection.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.object
};

TasksRelatedSection.defaultProps = {
  data: {}
};

export default React.memo(TasksRelatedSection);
